/**
 * @generated SignedSource<<71de96c1b7d4c12119f24cac3b242752>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespCreatorsComponents_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespFollowSearchBanner_user" | "SbSharedCreatorTopContent_user" | "SbSharedPageBreadcrumbs_user" | "SbSharedRelatedSellers_user" | "SbSharedTitle_user" | "SharedFollowSearchProvider_user" | "SharedFollowTopButton_user">;
  readonly " $fragmentType": "SbRespCreatorsComponents_user";
};
export type SbRespCreatorsComponents_user$key = {
  readonly " $data"?: SbRespCreatorsComponents_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespCreatorsComponents_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowSearchProvider_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedSellers_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedPageBreadcrumbs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCreatorTopContent_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bf4b784c6cf2e0c22c887b576bca37ba";

export default node;
